"use client"
import React from 'react';
import {Button} from "@/components/ui/button";
import {cn} from "@/lib/utils";
import {useRouter, useSearchParams} from "next/navigation";


function ClearFilterComponent() {
    const router = useRouter()
    const searchParams = useSearchParams()
    const clearFilters = () => {
        const searchValue = searchParams.get("search")
        router.push(`/search?search=${searchValue}`)
    }
    return (
        <Button
            onClick={clearFilters}
            variant={"outline"}
            className={cn("text-orange-primary shadow-none border-none")}
        >
            حذف فیلترها
        </Button>
    );
}

export default ClearFilterComponent;